import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Draggable } from 'gsap/Draggable';
import { helpers } from '../helpers';
import horizontalLoop from './horizontalLoop';
import loadVideos from '../videos';
import { parallaxAnim, summaryAnim } from '../animations';

gsap.registerPlugin(ScrollTrigger, Draggable);

// Detect Safari and add class to body for specific styling
if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
    document.body.classList.add('safari');
}

const infiniteLoop = () => {
    const marquees = document.querySelectorAll('.loop__track');

    marquees.forEach((marquee) => {
        const items = marquee.querySelectorAll('.loop__item');
        const loop = horizontalLoop(items, {
            repeat: -1,
            speed: 0.5,
            draggable: true,
            reversed: true,
            paddingRight: parseFloat(gsap.getProperty(items[0], 'marginRight', 'px')),
        });

        gsap.to(loop, { timeScale: marquee.dataset.direction, overwrite: true });
    });
};

const verticalLoop = () => {
    const nest = document.querySelector('.sliders__nest');
    const columns = document.querySelectorAll('.single-column');
    let imagesCount;

    columns.forEach((column) => {
        imagesCount = column.children.length;
        nest.style.setProperty('height', `${column.children[0].clientHeight * imagesCount}px`);
        column.style.setProperty('height', '200%');
        column.innerHTML = column.innerHTML + column.innerHTML;
        column.style.setProperty('--animation', 'slide');

        window.addEventListener('resize', () => {
            nest.style.setProperty('height', `${column.children[0].clientHeight * imagesCount}px`);
        });
    });
};

const bonusAnim = () => {
    const portrait = document.querySelectorAll('.bonus .bonus__phone .bonus__iphone-portrait');

    portrait.forEach((iphone) => {
        gsap.from(iphone, {
            y: 100,
            ease: 'none',
            scrollTrigger: {
                trigger: iphone,
                start: 'top bottom',
                end: 'top center',
                scrub: true,
            },
        });
    });

    const landscape = document.querySelectorAll('.bonus .bonus__iphone-landscape ');

    landscape.forEach((iphone) => {
        gsap.from(iphone, {
            x: 100,
            ease: 'none',
            scrollTrigger: {
                trigger: iphone,
                start: 'top bottom',
                end: 'top center',
                scrub: true,
            },
        });
    });
};

const igSectionAnim = () => {
    if (helpers.isPhone()) {
        return;
    }

    const section = document.querySelector('.last-ig-video');

    gsap.from(section, {
        y: 160,
        ease: 'none',
        scrollTrigger: {
            trigger: section,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
        },
    });
};

const fancyAnim = () => {
    // Skip animation in Crowdin environment to prevent text rendering issues
    if (window.App && (window.App.isCrowdin || window.App.appEnvironment === 'l10n')) {
        return;
    }

    const headings = document.querySelectorAll('.fancy');

    headings.forEach((heading) => {
        const isRTL = window.App?.isRTL || false;

        if (isRTL) {
            // For Arabic/RTL: animate word by word instead of letter by letter
            const words = heading.textContent.trim().split(/\s+/);

            const content = words.map((word, i) => {
                // Staggered delay for a smooth wave effect
                const delay = i * 250 + Math.floor(Math.random() * 200 + 1);
                return '<span class="arabic-word" style="transition-delay: ' + delay + 'ms">' + word + '</span>';
            });

            heading.innerHTML = content.join(' ');
        } else {
            // Original letter-by-letter animation for non-Arabic text
            const letters = heading.textContent.split('');

            const content = letters.map((val, i) => {
                const delay = Math.floor(Math.random() * 500 + 1);
                return '<span style="transition-delay: ' + delay + 'ms">' + val + '</span>';
            });

            heading.innerHTML = '';

            for (var i = 0; i < content.length; i++) {
                heading.innerHTML += content[i];
            }
        }

        ScrollTrigger.create({
            trigger: heading,
            start: 'top bottom+=200',
            onEnter: () => {
                heading.classList.add('fancy--anim');
            },
        });
    });
};

window.addEventListener('load', () => {
    loadVideos();
    verticalLoop();
    bonusAnim();
    fancyAnim();
    infiniteLoop();
    parallaxAnim();
    summaryAnim();
    igSectionAnim();
});
